import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const ApresentacaoContext = createContext();

export const useApresentacao = () => useContext(ApresentacaoContext);

export const ApresentacaoProvider = ({ children }) => {
    const [apresentacoes, setApresentacoes] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchApresentacoes = useCallback(async () => {
        try {
            const result = await fetchData('/Apresentacao');
            setApresentacoes(result);
        } catch (error) {
            console.error("Erro ao buscar apresentações:", error);
            showMessage(`Erro ao buscar apresentações! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchApresentacoes();
    }, [fetchApresentacoes]);

    const addApresentacao = async (apresentacao) => {
        try {
            const result = await postData('/Apresentacao', apresentacao);
            setApresentacoes([...apresentacoes, result]);
            showAlert('Apresentação adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar apresentação:", error);
            showMessage('Erro ao adicionar apresentação!\n' + error, 'danger');
        }
    };

    const updateApresentacao = async (apresentacao) => {
        try {
            const result = await putData('/Apresentacao', apresentacao);
            setApresentacoes((prev) =>
                prev.map((a) => (a.id === result.id ? result : a))
            );
            showAlert('Apresentação alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar apresentação:", error);
            showAlert('Erro ao alterar apresentação!', 'danger');
        }
    };

    const deleteApresentacao = async (id) => {
        try {
            await deleteData('/Apresentacao', { apresentacaoId: id });
            setApresentacoes(apresentacoes.filter(a => a.id !== id));
            showAlert('Apresentação excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir apresentação:", error);
            showAlert('Erro ao excluir apresentação!', 'danger');
        }
    };

    return (
        <ApresentacaoContext.Provider value={{ apresentacoes, addApresentacao, updateApresentacao, deleteApresentacao }}>
            {children}
        </ApresentacaoContext.Provider>
    );
};